var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCate01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  fillRule: "evenodd",
  d: "M21.764 3.75H4.237v18.5h17.527zm-3.652 4.723H7.888v1.266h10.224zM7.888 12.368h10.224v1.265H7.888zm10.224 3.894H7.888v1.266h10.224z",
  clipRule: "evenodd"
})));
export default SvgIconCate01;